// extracted by mini-css-extract-plugin
export var active = "_80-2";
export var container = "_80-0";
export var expired = "_80-3";
export var hasStatus = "_80-4";
export var statusChip = "_80-1";